var _path, _polygon, _path2, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRollRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 436.8 566.9",
    enableBackground: "new 0 0 436.8 566.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#000000",
    strokeMiterlimit: 10,
    d: "M37.9,552"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    points: "33.6,119 393.9,38.4 393.9,386.6 395,456.2 35.7,548.6 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M417.9,38.4c0-12.4-7.6-21.1-20-21.1c-1.8,0-3.5,0.2-5.1,0.6 c-0.2-0.2-0.3-0.3-0.3-0.3L46.8,89.4l-10.7,18.1l7.6,18l5.4,8.9c0,0,340.2-72.3,349.2-72.3c0,0,0,0,0,0 C410.6,61.8,417.9,50.6,417.9,38.4z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeWidth: 0.8517,
    strokeMiterlimit: 10,
    cx: 48.6,
    cy: 112.1,
    rx: 16,
    ry: 22.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollRegular);
export default __webpack_public_path__ + "static/media/roll_regular.288873758ca9cd39a16d395d2a240979.svg";
export { ForwardRef as ReactComponent };